import { render, staticRenderFns } from "./SchoolHome.vue?vue&type=template&id=88b8131e&scoped=true"
import script from "./SchoolHome.vue?vue&type=script&lang=js"
export * from "./SchoolHome.vue?vue&type=script&lang=js"
import style0 from "./SchoolHome.vue?vue&type=style&index=0&id=88b8131e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88b8131e",
  null
  
)

export default component.exports